"use client";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, InputField } from "@vionixasia/shared-components";
import { AdminShell } from "@/components/AdminShell";
import { apiClient } from "@/lib/api-client";
import type { MessagingProject, ProjectType } from "@/types/project";

function slugify(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

export default function NewProjectPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    slug: "",
    type: "timing_result" as ProjectType,
    status: "active",
    whatsapp_phone_number_id: "",
    whatsapp_business_account_id: "",
    default_template_language: "id",
    result_base_url: "",
  });
  const [saving, setSaving] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setSaving(true);
    const payload = { ...form, slug: form.slug || slugify(form.name) };
    const data = await apiClient<{ project: MessagingProject }>("/api/projects", { method: "POST", body: JSON.stringify(payload) });
    navigate(`/dashboard/project?projectId=${data.project.id}`, { replace: true });
  }

  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold text-ink">Create Project</h1>
      <form onSubmit={submit} className="mt-6 grid max-w-3xl gap-4 rounded-card border border-line bg-white p-5 sm:grid-cols-2">
        <InputField label="Project name" name="name" required value={form.name} onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))} labelColor="text-ink" />
        <InputField label="Slug" name="slug" value={form.slug} onChange={(e) => setForm((prev) => ({ ...prev, slug: e.target.value }))} labelColor="text-ink" />
        <InputField
          label="Type"
          name="type"
          type="select"
          value={form.type}
          onChange={(e) => setForm((prev) => ({ ...prev, type: e.target.value as ProjectType }))}
          labelColor="text-ink"
          defaultOptionLabel={null}
          options={[
            { value: "timing_result", label: "timing_result" },
            { value: "customer_service", label: "customer_service" },
            { value: "ai_agent", label: "ai_agent" },
            { value: "general", label: "general" },
          ]}
        />
        <InputField
          label="Status"
          name="status"
          type="select"
          value={form.status}
          onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))}
          labelColor="text-ink"
          defaultOptionLabel={null}
          options={[
            { value: "active", label: "active" },
            { value: "inactive", label: "inactive" },
          ]}
        />
        <InputField label="WhatsApp phone number ID" name="whatsapp_phone_number_id" value={form.whatsapp_phone_number_id} onChange={(e) => setForm((prev) => ({ ...prev, whatsapp_phone_number_id: e.target.value }))} labelColor="text-ink" />
        <InputField label="Business account ID" name="whatsapp_business_account_id" value={form.whatsapp_business_account_id} onChange={(e) => setForm((prev) => ({ ...prev, whatsapp_business_account_id: e.target.value }))} labelColor="text-ink" />
        <InputField label="Template language" name="default_template_language" value={form.default_template_language} onChange={(e) => setForm((prev) => ({ ...prev, default_template_language: e.target.value }))} labelColor="text-ink" />
        <InputField label="Result base URL" name="result_base_url" value={form.result_base_url} onChange={(e) => setForm((prev) => ({ ...prev, result_base_url: e.target.value }))} labelColor="text-ink" />
        <div className="sm:col-span-2">
          <Button type="submit" color="teal" disabled={saving}>
            {saving ? "Saving..." : "Save Project"}
          </Button>
        </div>
      </form>
    </AdminShell>
  );
}
